import React, { Component } from 'react';
import { withRouter } from 'react-router'

import Dashboard from './Dashboard';
import WorkOrderList from './WorkOrderList';
import ExportCKFileList from './ExportCKFileList';
import ImportFileList from './ImportFileList';
import ImportItemList from './ImportItemList';
import WorkOrderWork from './WorkOrderWork';
import WorkOrderDetails from './WorkOrderDetails';
import WorkOrderService from './WorkOrderService';
import WorkOrderDesign from './WorkOrderDesign';
import ShipWorkOrderDetails from './ShipWorkOrderDetails';
import ShipWorkOrderScan from './ShipWorkOrderScan';
import ShipWorkOrderPrint from './ShipWorkOrderPrint';


import KimScan from './KimScan';
import LenScan from './LenScan';
import XiScan from './XiScan';
import BongScan from './BongScan';

import WorkOrderDetailsPrint from './WorkOrderDetailsPrint'
import OrderList from './OrderList';

import ShipProductList from './ShipProductList';
import ShipWorkOrderList from './ShipWorkOrderList';
import ShipPackageList from './ShipPackageList';
import ErrorList from './ErrorList';

import ShipOrderScan from './ShipOrderScan'
import ProductList from './ProductList';
import KhacList from './KhacList';
import XiList from './XiList';
import HistoryList from './HistoryList';
import SuperList from './SuperList';
import SuperListExt from './SuperListExt';
import ChangedWoList from './ChangedWoList';
import ItemList from './ItemList';
import ItemMappingList from './ItemMappingList';
import TalkList from './TalkList';
import ItemDetailsView from './ItemDetailsView';
import ItemDetailsEdit from './ItemDetailsEdit';
import UserList from './UserList';
import UserDetailsEdit from './UserDetailsEdit';
import UserDetailsAdd from './UserDetailsAdd';
import ShopList from './ShopList';
import ShopDetailsEdit from './ShopDetailsEdit';
import Settings from './Settings';
import Material from './Material';
import MaterialStock from './MaterialStock';
import OrderPrintResult from './OrderPrintResult';
import Logs from './Logs';
import SQLExecutor from './SQLExecutor';

import { Route, Switch } from 'react-router-dom'
import LoginComponent from './LoginComponent';
import LogoutComponent from './LogoutComponent';
import AuthenticatedRoute from './AuthenticatedRoute';
import LenDaList from './LenDaList';
import ShipDHL from './ShipDHL';
import SettingsByService from "./SettingsByService";
import PrintTailList from './PrintTailList';
import Report from './Report';
import PlanningSimple from './PlanningSimple';
import QualityReport from './QualityReport';
import ServiceWorkOrderScan from './ServiceWorkOrderScan';
import QualityProductList from './QualityProductList';
import DeliveryPackageList from './DeliveryPackageList';
import KhacSearchList from './KhacSearchList';
import DeliveryShipWorkOrderScan from './DeliveryShipWorkOrderScan';
import ShipBasketScan from './ShipBasketScan';
import ErrorReport from './ErrorReport';
import KhaiHq from './KhaiHq';
import KcsProductList from './KcsProductList';

class InstructorApp extends Component {
    handleUpdate(){
        
    }

    routerWillLeave(nextLocation) { 
        return 'You have unsaved information, are you sure you want to leave this page' 
    }

    componentWillMount() {
        this.unlisten = this.props.history.listen((location, action) => {
            let previousPath = sessionStorage.getItem("PreviousPath");
            if (previousPath === null || previousPath === undefined) {
                sessionStorage.setItem("PreviousPath", location.pathname);
                return;
            }
            // if (previousPath.indexOf("/workOrders/edit") >= 0){
            //    alert("Do you want to save?");
            // }
            sessionStorage.setItem("PreviousPath", location.pathname);
            // console.log('You changed the page to: ' + location)
        });

        
    }
    componentWillUnmount() {
        this.unlisten();
    }    

    render() {
        return (
        <div className="content-inner" key="index_1234">
            <Switch>
                <Route path="/login" exact component={LoginComponent}/>                            
                <AuthenticatedRoute path="/" exact component={Dashboard} />
                <AuthenticatedRoute path="/logout" exact component={LogoutComponent} />
                <AuthenticatedRoute path="/importedFiles" exact component={ImportFileList} />
                <AuthenticatedRoute path="/importedItems" exact component={ImportItemList} />
                <AuthenticatedRoute path="/workOrders" exact component={WorkOrderList} />
                <AuthenticatedRoute path="/ckfiles" exact component={ExportCKFileList} />
                <AuthenticatedRoute path="/workOrders/view/:id" exact component={WorkOrderWork} />
                <AuthenticatedRoute path="/workOrders/service/:id" exact component={WorkOrderService} />
                <AuthenticatedRoute path="/workOrders/edit/:id" exact component={WorkOrderDetails} />
                <AuthenticatedRoute path="/workOrders/design/:id" exact component={WorkOrderDesign} />
                <AuthenticatedRoute path="/workOrders/print/:id" exact component={WorkOrderDetailsPrint} />
                <AuthenticatedRoute path="/orders" exact component={OrderList} />

                <AuthenticatedRoute path="/shipOrders" exact component={ShipProductList} />
                <AuthenticatedRoute path="/hoanthanh" exact component={KcsProductList} />
                <AuthenticatedRoute path="/ship" exact component={ShipWorkOrderList} />
                <AuthenticatedRoute path="/workOrders/shipping/:id" exact component={ShipWorkOrderDetails} />                
                <AuthenticatedRoute path="/shipOrdersScan" exact component={ShipOrderScan} />
                <AuthenticatedRoute path="/shipWorkOrderScan" exact component={ShipWorkOrderScan} />
                <AuthenticatedRoute path="/ShipBasketScan" exact component={ShipBasketScan} />
                <AuthenticatedRoute path="/serviceWorkOrderScan" exact component={ServiceWorkOrderScan} />
                <AuthenticatedRoute path="/shipWorkOrderPrint" exact component={ShipWorkOrderPrint} />
                <AuthenticatedRoute path="/shipPackages" exact component={ShipPackageList} />
                <AuthenticatedRoute path="/khaihq" exact component={KhaiHq} />
                <AuthenticatedRoute path="/shipDHL" exact component={ShipDHL} />
                <AuthenticatedRoute path="/errors" exact component={ErrorList} />

                <AuthenticatedRoute path="/kimScan" exact component={KimScan} />
                <AuthenticatedRoute path="/LenScan" exact component={LenScan} />

                <AuthenticatedRoute path="/bongScan" exact component={BongScan} />
                <AuthenticatedRoute path="/XiScan" exact component={XiScan} />
                
                <AuthenticatedRoute path="/products" exact component={ProductList} />
                <AuthenticatedRoute path="/qualityproducts" exact component={QualityProductList} />
                <AuthenticatedRoute path="/khacs" exact component={KhacList} />
                <AuthenticatedRoute path="/lendas" exact component={LenDaList} />
                <AuthenticatedRoute path="/xis" exact component={XiList} />
                <AuthenticatedRoute path="/histories" exact component={HistoryList} />
                <AuthenticatedRoute path="/super" exact component={SuperList} />
                <AuthenticatedRoute path="/superext" exact component={SuperListExt} />
                <AuthenticatedRoute path="/changedWo" exact component={ChangedWoList} />
                <AuthenticatedRoute path="/orders/print" exact component={OrderPrintResult} />
                <AuthenticatedRoute path="/items" exact component={ItemList} />
                <AuthenticatedRoute path="/itemmappings" exact component={ItemMappingList} />
                <AuthenticatedRoute path="/items/add" exact component={ItemDetailsEdit} />
                <AuthenticatedRoute path="/items/view/:id" exact component={ItemDetailsView} />
                <AuthenticatedRoute path="/items/edit/:id" exact component={ItemDetailsEdit} />
                <AuthenticatedRoute path="/users" exact component={UserList} />
                <AuthenticatedRoute path="/users/add" exact component={UserDetailsAdd} />
                <AuthenticatedRoute path="/users/edit/:id" exact component={UserDetailsEdit} />
                <AuthenticatedRoute path="/shops" exact component={ShopList} />
                <AuthenticatedRoute path="/shops/add" exact component={ShopDetailsEdit} />
                <AuthenticatedRoute path="/shops/edit/:id" exact component={ShopDetailsEdit} />
                <AuthenticatedRoute path="/settings" exact component={Settings} />
                <AuthenticatedRoute path="/settingsbyservice" exact component={SettingsByService} />
                <AuthenticatedRoute path="/materials" exact component={Material} />
                <AuthenticatedRoute path="/materialStocks" exact component={MaterialStock} />
                <AuthenticatedRoute path="/logs" exact component={Logs} />
                <AuthenticatedRoute path="/sql" exact component={SQLExecutor} />
                <AuthenticatedRoute path="/talks" exact component={TalkList} />
                <AuthenticatedRoute path="/prt" exact component={PrintTailList} />
                <AuthenticatedRoute path="/report" exact component={Report} />
                <AuthenticatedRoute path="/pls" exact component={PlanningSimple} />
                <AuthenticatedRoute path="/qr" exact component={QualityReport} />
                <AuthenticatedRoute path="/dpk" exact component={DeliveryPackageList} />
                <AuthenticatedRoute path="/dsus" exact component={DeliveryShipWorkOrderScan} />
                <AuthenticatedRoute path="/khacsearch" exact component={KhacSearchList} />
                <AuthenticatedRoute path="/er" exact component={ErrorReport} />
            </Switch>
        </div>
        )
    }
}

export default withRouter(InstructorApp)